import { render, staticRenderFns } from "./AddItemButton.vue?vue&type=template&id=e975d4de&scoped=true&"
import script from "./AddItemButton.vue?vue&type=script&lang=js&"
export * from "./AddItemButton.vue?vue&type=script&lang=js&"
import style0 from "./AddItemButton.vue?vue&type=style&index=0&id=e975d4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e975d4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e975d4de')) {
      api.createRecord('e975d4de', component.options)
    } else {
      api.reload('e975d4de', component.options)
    }
    module.hot.accept("./AddItemButton.vue?vue&type=template&id=e975d4de&scoped=true&", function () {
      api.rerender('e975d4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/buttons/AddItemButton.vue"
export default component.exports